import { Design, NodeType } from '../../../types';

export function normalizeDisambiguationPrompt(
  itemWithOverride: {
    disambiguationPromptId?: string;
  },
  { components: { objects } }: Design
): void {
  if (
    !itemWithOverride.disambiguationPromptId
    // No matching prompt.
    || !objects.some(({ _class, id }) => {
      return (
        _class === NodeType.prompt
        && id === itemWithOverride.disambiguationPromptId
      );
    })
  ) {
    delete itemWithOverride.disambiguationPromptId;
  }
}
